import { useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";

const pingDomain = process.env.REACT_APP_PING_DOMAIN;

const PingLayout = () => {
  const [isPageVisible, setIsPageVisible] = useState(true);
  const pingIntervalRef = useRef(null); // ✅ useRef for shared mutable pingInterval

  useEffect(() => {
    const dcCode = localStorage.getItem("dcCode");
    const url = `https://${dcCode}-${pingDomain}/nms/ping`;

    const pingApi = async () => {
      try {
        const response = await fetch(url, {
          headers: {
            "X-Api-Key": process.env.REACT_APP_APIKEY,
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        console.log("Ping API status:", response.status);

        if (!response.ok) {
          if (response.status === 401) {
            console.warn("401 Unauthorized. Redirecting...");
            localStorage.clear();

            if (pingIntervalRef.current) {
              clearInterval(pingIntervalRef.current); // ✅ clear actual interval
            }

            window.location.replace(process.env.REACT_APP_JIOCLOUD_HOME_URL); // ✅ safer redirect
          } else {
            throw new Error("Ping failed with status: " + response.statusText);
          }
        }
      } catch (error) {
        console.error("Error in pingApi:", error);
      }
    };

    // Start interval
    pingIntervalRef.current = setInterval(() => {
      if (isPageVisible) {
        pingApi();
      }
      console.log("hello time interval");
    }, 30000);

    const handleVisibilityChange = () => {
      setIsPageVisible(document.visibilityState !== "hidden");
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      // Cleanup on unmount
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isPageVisible]);

  return <Outlet />;
};

export default PingLayout;
